module.exports = __webpack_public_path__ + "static/media/meat.4c503d6b.svg";